import { makeAPIRequest } from "./makeRequest";

interface configData  {
    method: string;
    url: string;
    headers: Record<string, string>;
    data?: any;
}

let config: configData = {
    method: 'GET',
    url:"",
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
}

export const GetDealerships = (userName: string) => {
    config.url = process.env.REACT_APP_SERVER_URL + 'Director/GetDealersForDirectorLogin?username=' + userName;

    let res = makeAPIRequest(config);
    return res;
}